<template></template>

<script>
export default {
  data(){
    return{
      isExpandContactWidget: false,
    }
  },
  methods:{
    expandContactWidget(id){
      this.isExpandContactWidget = !this.isExpandContactWidget;
    },
  },
}
</script>

<style scoped>

</style>